import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import Histogram from '../Plot/Histogram/Histogram';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';

interface HistogramBoxProps {
  activePlotAnalytics: string | null;
  previewDatasetId: string;
  coordinates: number[];
  datasets: IBestDataset[];
  dateRange: any;
  enrichedMetadata: IEnrichedMetadata[];
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  updating: boolean;
  histogramImage: string;
  histogramLinks: string[];
  error: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  point?: MarkerItem;
  onDatasetChange: (value: string) => void;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
  gridCellSize: string;
  waterDepth: string;
}

const HistogramBox: React.FC<HistogramBoxProps> = ({
  activePlotAnalytics,
  previewDatasetId,
  coordinates,
  datasets,
  dateRange,
  enrichedMetadata,
  onUpdate,
  updating,
  histogramImage,
  histogramLinks,
  error,
  pointName,
  userInput,
  updateUserInput,
  point,
  onDatasetChange,
  onChangeActiveKey,
  pointOption,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset,
  gridCellSize,
  waterDepth,
}) => {
  if (
    !(
      activePlotAnalytics === 'Histogram' ||
      activePlotAnalytics === 'Histogram (w. Weibull Parameters)'
    )
  ) {
    return null;
  }

  return (
    <Histogram
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      datasets={datasets}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      onUpdate={onUpdate}
      updating={updating}
      histogramImage={histogramImage}
      histogramLinks={histogramLinks}
      error={error}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      point={point}
      onDatasetChange={onDatasetChange}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}
      waterDepth={waterDepth}
      gridCellSize={gridCellSize}
    />
  );
};

export default HistogramBox;
